import './testOrderSummaryDetailsComponent.scss'
import React, {useEffect, useState} from 'react';
import TestOrderSummaryViewComponent from "./test-order-summary-view/testOrderSummaryViewComponent";

interface TestOrderSummaryDetailsComponentProps {
    testOrderDetails: any;
    onModeChange: Function;
}

const TestOrderSummaryDetailsComponent = (props: TestOrderSummaryDetailsComponentProps) => {
        const {testOrderDetails, onModeChange} = props;
        const [mode] = useState<"view" | "edit">("view");
        const [testOrderBasicInformation, setTestOrderSummary] = useState<any>(undefined);

        useEffect(() => {
            if (testOrderDetails) {
                setTestOrderSummary(testOrderDetails);
            }
        }, [testOrderDetails]);

        useEffect(() => {
            onModeChange(mode)
        }, [mode, onModeChange]);

        return (
            <div className="patient-information-component details-tab-data-wrapper">
                {
                    mode === "view" && <TestOrderSummaryViewComponent
                        testOrderDetails={testOrderBasicInformation}
                    />
                }
            </div>
        )
    }

;

export default TestOrderSummaryDetailsComponent;